import get from 'lodash/get'
import settings from '../../settings'
import ensureSlash from './ensureSlash'

const getRequestEndpoint = (
  signatureUrl = get(settings, 'uploads.signatureUrl')
) => (signatureUrl != null ? ensureSlash(signatureUrl) : signatureUrl)

export default getRequestEndpoint
